import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    AppBar, Toolbar, Typography, CircularProgress, Select, SelectChangeEvent, MenuItem, Pagination, TextField
} from '@mui/material';
import {Add} from '@mui/icons-material';
import {
    fetchStatistics, fetchStatisticsTable, getAllQuizzes, getQuizzes
} from '../services/api';
import {QuizModel, StatisticsModel} from "../services/types";

interface Statistics {
    "unique_users": number;
    "total_quizzes_completed": number;
    "total_correct_answers": number;
    "total_incorrect_answers": number;
}

const Statistics: React.FC = () => {
    const [statistics, setStatistics] = useState<Statistics>({
        unique_users: 0,
        total_quizzes_completed: 0,
        total_correct_answers: 0,
        total_incorrect_answers: 0
    });
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(true);
    const [quizes, setQuizes] = useState<QuizModel[]>([]);
    const [selectQuiz, setSelectQuiz] = useState<string>("Все");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [statitsticsTable, setStatisticsTable] = useState<StatisticsModel[]>([]);
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');


    useEffect(() => {
        const loadStatistics = async () => {
            try {
                const data = await fetchStatistics(selectQuiz);
                setStatistics(data)
                loadQuizes();
            } catch (error) {
                setLoading(false)
                console.error('Error fetching categories:', error);
            }
        };
        const loadQuizes = async () => {
            try {
                const data = await getAllQuizzes({
                    page: 1,
                    limit: 400,
                    sort_by: 'created_at',
                    sort_order: 'desc',
                });
                setQuizes(data.items)
                loadStatisticsTable()
            } catch (error) {
                setLoading(false)
                console.error('Error fetching categories:', error);
            }
        };
        loadStatistics();
    }, [selectQuiz, startDate, endDate]);

    const loadStatisticsTable = async () => {
        try {
            const data = await fetchStatisticsTable(page, 20, selectQuiz, startDate, endDate);
            setTotalPages(data.total_pages);
            setTotalElements(data.total);
            setLoading(false)
            setStatisticsTable(data.items)
            console.log(data.items)
        } catch (error) {
            setLoading(false)
            console.error('Error fetching categories:', error);
        }
    };

    useEffect(() => {
        loadStatisticsTable();
    }, [page])


    const handleQuizChange = (event: SelectChangeEvent<string>) => {
        const newQuizId = event.target.value;
        setSelectQuiz(newQuizId);
    };
    const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage);
    };

    // Обработчик изменения диапазона дат
    const handleDateChange = (type: 'start' | 'end', value: string) => {
        if (type === 'start') {
            setStartDate(value);
        } else if (type === 'end') {
            setEndDate(value);
        }
        setPage(1); // Сброс страницы при изменении диапазона дат
    };

    // Обработчик загрузки всех данных на одной странице
    const handleLoadAllData = async () => {
        setLoading(true)
        try {
            const data = await fetchStatisticsTable(page, 100000, selectQuiz, startDate, endDate);
            setTotalPages(data.total_pages);
            setTotalElements(data.total);
            setLoading(false)
            setStatisticsTable(data.items)
            console.log(data.items)
        } catch (error) {
            setLoading(false)
            console.error('Error fetching categories:', error);
        }
    };

    return (
        <Box>
            <AppBar className={loading ? 'headerBlock preloading' : 'headerBlock'} position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>Статистика <span>{totalElements}</span></Box>
                    <Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>
                </Toolbar>
            </AppBar>

            <Box className='topButtonsContainer mobileFlexColumn' sx={{mb:2}}>
                <Select
                    className='tvprogrammProjectsSelect'
                    value={selectQuiz}
                    onChange={handleQuizChange}
                    sx={{ minWidth: 500 }}
                >
                    <MenuItem key="emptyquiz" value="Все">Все</MenuItem>
                    {quizes.map((quiz) => (
                        <MenuItem key={quiz.id} value={quiz.id}>{quiz.title}</MenuItem>
                    ))}
                </Select>


                <Box>
                    <TextField
                        type="date"
                        label="Дата от"
                        InputLabelProps={{ shrink: true }}
                        value={startDate}
                        onChange={(e) => handleDateChange('start', e.target.value)}
                        sx={{ mr:2 }}
                    />
                    <TextField
                        type="date"
                        label="Дата до"
                        InputLabelProps={{ shrink: true }}
                        value={endDate}
                        onChange={(e) => handleDateChange('end', e.target.value)}
                        sx={{ mr:2 }}
                    />
                </Box>


                {/* Кнопка для загрузки всех данных */}
                <Button className="showAllBtn" variant="contained" onClick={handleLoadAllData}>
                    Загрузить все ответы
                </Button>
            </Box>

            {!loading ?
                <>
                    <Box className='homeWidgets'>
                        <Box className='homeWidget homeFourSize' sx={{backgroundColor: '#503391', color: '#fff'}}>
                            <Box className='statisticsCounter'>
                                <span style={{opacity: 0.7}}>Уникальных<br/> пользователей:</span><br/>
                                <b>{statistics.unique_users}</b>
                            </Box>
                        </Box>
                        <Box className='homeWidget homeFourSize' sx={{backgroundColor: '#503391', color: '#fff'}}>
                            <Box className='statisticsCounter'>
                                <span style={{opacity: 0.7}}>Завершено<br/> квизов:</span><br/>
                                <b>{statistics.total_quizzes_completed}</b>
                            </Box>
                        </Box>
                        <Box className='homeWidget homeFourSize' sx={{backgroundColor: '#503391', color: '#fff'}}>
                            <Box className='statisticsCounter'>
                                <span style={{opacity: 0.7}}>Верных ответов<br/> всего:</span><br/>
                                <b>{statistics.total_correct_answers}</b>
                            </Box>
                        </Box>
                        <Box className='homeWidget homeFourSize' sx={{backgroundColor: '#503391', color: '#fff'}}>
                            <Box className='statisticsCounter'>
                                <span style={{opacity: 0.7}}>Неверных ответов<br/> всего:</span><br/>
                                <b>{statistics.total_incorrect_answers}</b>
                            </Box>
                        </Box>
                    </Box>

                    <Box className='sourcesList' sx={{mt: 5}}>
                        <table cellPadding={0} cellSpacing={0}>
                            <tbody>
                                <tr style={{backgroundColor: '#503491', color: 'white'}}>
                                    <td style={{width: '130px'}}>IP адрес</td>
                                    <td style={{width: '20%'}}>Квиз</td>
                                    <td style={{width: '40%'}}>Вопрос</td>
                                    <td>Ответы</td>
                                    <td style={{width: '100px'}}>Верно или нет</td>
                                    <td style={{width: '100px'}}>Дата и время</td>
                                </tr>
                            </tbody>
                        </table>
                        <table cellPadding={0} cellSpacing={0}>
                            <tbody>
                            {statitsticsTable.map((stat) => (
                                <tr>
                                    <td style={{width: '130px'}}>{stat.ip_address}</td>
                                    <td style={{width: '20%'}}><b>{stat.quiz?.title}</b></td>
                                    <td style={{width: '40%'}}>{stat.question?.title}</td>
                                    <td>
                                        {stat.answers.length === 0 || !stat.question ? "нет вопроса" : (
                                            (stat.question.answers || []).map((answer) =>
                                                    stat.answers.includes(answer.id) && (
                                                        <div key={answer.id}>{answer.text}</div>
                                                    )
                                            )
                                        )}
                                    </td>
                                    <td style={{width: '100px'}}>{stat.is_correct ? 'Верный ответ' : ''}</td>
                                    <td style={{width: '100px'}}>{new Date(stat.created_at).toLocaleString('ru-RU', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                    }).replace(',', '')}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>

                    </Box>
                    {(totalPages > 1) && (
                        <Pagination className='paginationElement' count={totalPages} page={page} onChange={handlePageChange} />
                    )}
                </>

                :
                <Box className='notFoundElements' sx={{}}>
                    <CircularProgress/>
                </Box>
            }
        </Box>
    );

};

export default Statistics;
